import {useState} from "react";
import {Col, Dropdown, Row} from "react-bootstrap";
import {UseLimit, UseOrder} from "../../hooks/settings";

import Select from "../input/select";
import Button from "../button";
import Icon from "../icon";

const Tools = (props) => {
    const {
        addons, actions, checked, onChangeAction, onClickApply, filters,
        onChangeLimit, onChangeOrder, searchActive, setSearchActive
    } = props

    const [hasBulkAction, setHasBulkAction] = useState(false)

    const handleActionChange = (ev) => {
        setHasBulkAction(true)
        onChangeAction(ev)
    }

    return (
        <Row>
            <Col xs={6} className="d-flex align-items-center col-6">
                <div className="d-flex">
                    {addons?.top?.left && <div>
                        {addons.top.left}
                    </div>}
                    <div>
                        <Select
                            isReady={true}
                            options={actions}
                            className="min-width-130"
                            placeholder="Bulk Actions"
                            onChange={handleActionChange}
                        />
                    </div>
                    <div className="ms-2">
                        <Button
                            size="sm"
                            icon="check2"
                            isReady={true}
                            className="fw-700"
                            style={{height: '32px'}}
                            color={!hasBulkAction ? "light" : "primary"}
                            onClick={ev => onClickApply(checked)}
                        />
                    </div>
                </div>
            </Col>
            <Col xs={6} className="d-flex justify-content-end align-items-center">
                <div className="d-flex">
                    <Button isReady={true} size="md" color="white" onClick={ev => setSearchActive(!searchActive)}>
                        <Icon name="search"/>
                    </Button>

                    {filters && <Dropdown className="table-filters">
                        <Dropdown.Toggle variant="white" id="dropdown-basic">
                            <Icon name="filter"/>
                        </Dropdown.Toggle>
                        <Dropdown.Menu align="start">
                            <strong className="dropdown-title">Filters</strong>
                            {filters}
                        </Dropdown.Menu>
                    </Dropdown>}

                    <Dropdown>
                        <Dropdown.Toggle variant="white" id="dropdown-basic">
                            <Icon name="settings"/>
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <strong className="dropdown-title">Show</strong>
                            <Dropdown.Item active={parseInt(UseLimit()) === 5} href="#" onClick={onChangeLimit}>
                                5
                            </Dropdown.Item>
                            <Dropdown.Item href="#" active={parseInt(UseLimit()) === 30} onClick={onChangeLimit}>
                                30
                            </Dropdown.Item>
                            <Dropdown.Item href="#" active={parseInt(UseLimit()) === 60} onClick={onChangeLimit}>
                                60
                            </Dropdown.Item>
                            <Dropdown.Item href="#" active={parseInt(UseLimit()) === 120} onClick={onChangeLimit}>
                                120
                            </Dropdown.Item>

                            <strong className="dropdown-title">Order</strong>
                            <Dropdown.Item active={UseOrder() === 'ASC'} href="#" onClick={onChangeOrder}>
                                ASC
                            </Dropdown.Item>
                            <Dropdown.Item href="#" active={UseOrder() === 'DESC'} onClick={onChangeOrder}>
                                DESC
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </Col>
        </Row>
    )
}

export default Tools